import axiosPost from "./axiosPost";

export const RNHServicioUpd = async (credentials, data) => {
    const body = {
        service: "RNHServicioUpd",
        params: {
            rnhServicioId: data?.id,
            rnhServicioCod: data?.cod,
            rnhServicioNombre: data?.name,
            rnhServicioDescripcion: data?.desc,
            rnhServicioVersion: data?.version,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
